// Day.js + plugins, bundled locally to replace Moment.js / moment-timezone.
//
// Built to dist-js/dayjs.min.js (see rollup.config.mjs) and enqueued as a
// same-origin script so it loads as reliably as the rest of the theme bundle —
// unlike the previous CDN dayjs, which WP Rocket Delay-JS / blocked CDNs left
// undefined (the source of the recurring "dayjs is not defined" Sentry errors).
//
// Exposes window.dayjs with the API surface our code uses:
//   utc + timezone        → dayjs.tz(), dayjs.tz.guess(), zone-aware format()
//   advancedFormat        → 'Do' and other extended format tokens
//   customParseFormat     → parsing non-ISO strings with explicit formats
//   isBetween             → dayjs().isBetween(a, b)
//
// Imports the pure-ESM build (dayjs/esm/*) so rollup's nodeResolve handles it
// without a CommonJS plugin.
import dayjs from "dayjs/esm/index.js";
import utc from "dayjs/esm/plugin/utc/index.js";
import timezone from "dayjs/esm/plugin/timezone/index.js";
import advancedFormat from "dayjs/esm/plugin/advancedFormat/index.js";
import customParseFormat from "dayjs/esm/plugin/customParseFormat/index.js";
import isBetween from "dayjs/esm/plugin/isBetween/index.js";

dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.extend(advancedFormat);
dayjs.extend(customParseFormat);
dayjs.extend(isBetween);

window.dayjs = dayjs;
